/* Resin Floor Supplies — collection page (v2, 30-9-2026).
   Room tiles, product-type / option / price / stock filters that work together (OR inside a group, AND across groups),
   counts worked out with the other active groups applied, variant-aware matching (a product only matches when one real
   variant has every selected option), matching info on cards, sort, compare (up to 3) and state kept for the back button. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rfc]');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var grid = $('[data-rfc-grid]');
  var cards = $$('[data-rfc-card]');
  if (!grid || !cards.length) return;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  var VAT = (function () { var v = $('.rfc-card__vat'); return v ? v.textContent.trim() : ''; })();
  var mqSmall = window.matchMedia('(max-width: 989px)');
  var mqPhone = window.matchMedia('(max-width: 599px)');

  var roomNames = {};
  try { roomNames = JSON.parse($('[data-rfc-rooms]').textContent); } catch (e) { roomNames = {}; }

  /* tidy option values so "5l", "5L", "5 Litres" become one choice */
  var UNITS = { kg: 'kg', g: 'g', ml: 'ml', l: 'L', litre: 'L', litres: 'L', mm: 'mm', cm: 'cm', m: 'm' };
  function cleanVal(v) {
    var s = String(v).trim();
    var t = s.replace(/\(.*?\)/g, '').trim().replace(/^(\d+) (\d+)(?=\s*[a-z])/i, '$1.$2');
    var m = t.match(/^(\d+(?:\.\d+)?)\s*(kg|g|ml|litres|litre|l|mm|cm|m)$/i);
    return m ? m[1] + ' ' + UNITS[m[2].toLowerCase()] : s;
  }
  function norm(n) { return String(n).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().replace(/^anti slip /, ''); }
  function isColName(n) { return /colou?r/.test(n); }
  function isSizeName(n) { return /(^| )(size|pack|volume|weight)( |$)/.test(n) || n === 'pack size'; }
  function numOf(v) { var m = String(v).replace(',', '.').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; }
  function unitOf(v) { var m = String(v).match(/\d\s*([a-zA-Z]+)$/); return m ? m[1] : ''; }
  function niceColour(v) { var m = String(v).match(/^(.*?)\s*\((blend)\)\s*$/i); return m ? { t: m[1], s: 'blend' } : { t: v, s: '' }; }

  var FIN = [
    ['matt', 'Matt', 'Flat, hides wall flaws'],
    ['soft-sheen', 'Soft sheen', 'Low sheen, wipes clean'],
    ['eggshell', 'Eggshell', 'Mid-sheen, walls & wood'],
    ['silk', 'Silk', 'Highest sheen of the four']
  ];
  var COL = [
    ['ready', 'Ready-made colours', 'Stock shades, ready to use'],
    ['designer', 'Designer colours', 'Named shades, ready mixed'],
    ['ral', 'Any RAL / BS code', 'Mixed to your colour code']
  ];
  var BANDS = [
    ['b0', 'Under £25', 0, 2500], ['b1', '£25 – £50', 2500, 5000], ['b2', '£50 – £100', 5000, 10000],
    ['b3', '£100 – £250', 10000, 25000], ['b4', '£250 – £500', 25000, 50000], ['b5', '£500 and over', 50000, Infinity]
  ];

  /* ---------- read the cards ---------- */
  var data = cards.map(function (el) {
    var sizes = (el.getAttribute('data-sizes') || '').split(',').filter(Boolean).map(Number);
    var vj = { o: [], v: [] };
    try { vj = JSON.parse($('[data-rfc-v]', el).textContent); } catch (e) {}
    var onames = (vj.o || []).map(norm);
    var V = (vj.v || []).map(function (x) {
      return { id: x[0], raw: x[1] || [], o: (x[1] || []).map(function (s) { return cleanVal(s).toLowerCase(); }), p: Number(x[2]) || 0, a: !!x[3], img: x[4] || '' };
    });
    var img = $('.rfc-card__media img', el);
    var d = {
      el: el, i: Number(el.getAttribute('data-i')),
      price: Number(el.getAttribute('data-price')) || 0,
      name: el.getAttribute('data-name') || '',
      finish: el.getAttribute('data-finish') || '',
      flabel: el.getAttribute('data-flabel') || '',
      colour: (el.getAttribute('data-colour') || '').split(/\s+/).filter(Boolean),
      sizes: sizes, unit: el.getAttribute('data-unit') || '',
      rooms: (el.getAttribute('data-rooms') || '').split(/\s+/).filter(Boolean),
      sizechip: el.getAttribute('data-sizechip') || '', colchip: el.getAttribute('data-colchip') || '',
      kind: el.getAttribute('data-kind') || '', klabel: el.getAttribute('data-klabel') || '',
      includes: el.getAttribute('data-includes') || '', packnote: el.getAttribute('data-packnote') || '',
      coverage: el.getAttribute('data-coverage') || '',
      url: el.getAttribute('data-url') || '#',
      onames: vj.o || [], on: onames, V: V,
      img: img, imgSrc: img ? img.getAttribute('src') : '', imgSet: img ? img.getAttribute('srcset') : '',
      chips: $('[data-rfc-chips]', el), chipsHTML: '', match: $('[data-rfc-match]', el), note: $('[data-rfc-imgnote]', el),
      pEl: $('[data-rfc-price]', el), fromEl: $('[data-rfc-from]', el), basisEl: $('[data-rfc-basis]', el),
      links: $$('[data-rfc-link]', el), shown: 0
    };
    d.chipsHTML = d.chips ? d.chips.innerHTML : '';
    d.optVals = function (n) {
      var k = d.on.indexOf(n); if (k < 0) return [];
      var out = [];
      d.V.forEach(function (v) { var raw = cleanVal(v.raw[k]); if (out.indexOf(raw) < 0) out.push(raw); });
      return out;
    };
    return d;
  });

  /* ---------- build the filter groups ---------- */
  var groups = [];
  var count = function (fn) { return data.filter(fn).length; };

  var kinds = [];
  data.forEach(function (d) { if (d.kind && kinds.indexOf(d.kind) < 0) kinds.push(d.kind); });
  if (kinds.length > 1) groups.push({ key: 'kind', label: 'Product type', lvl: 'p', style: 'pills', all: true,
    opts: kinds.map(function (k) { return { v: k, label: k }; }), test: function (d, v) { return d.kind === v; } });

  var finOpts = FIN.filter(function (f) { return count(function (d) { return d.finish === f[0]; }) > 0; });
  if (finOpts.length > 1) groups.push({ key: 'finish', label: 'Finish', sub: 'flat to shiny', lvl: 'p', style: 'finish',
    opts: finOpts.map(function (f) { return { v: f[0], label: f[1], small: f[2] }; }), test: function (d, v) { return d.finish === v; } });

  var colOpts = COL.filter(function (c) { return count(function (d) { return d.colour.indexOf(c[0]) > -1; }) > 0; });
  var shownCol = colOpts.length > 1;
  if (shownCol) groups.push({ key: 'colour', label: 'Colour', lvl: 'p', style: 'checks',
    opts: colOpts.map(function (c) { return { v: c[0], label: c[1], small: c[2] }; }), test: function (d, v) { return d.colour.indexOf(v) > -1; } });

  /* emulsion-style pack buckets (one unit across the collection) */
  var units = [], unit = '';
  data.forEach(function (d) { if (d.unit && units.indexOf(d.unit) < 0) units.push(d.unit); });
  unit = units[0] || '';
  var big = [];
  data.forEach(function (d) { d.sizes.forEach(function (s) { if (s > 5 && big.indexOf(s) < 0) big.push(s); }); });
  big.sort(function (a, b) { return a - b; });
  var PACK = [];
  if (data.some(function (d) { return d.sizes.some(function (s) { return s <= 5; }); })) PACK.push({ v: 's', label: 'Up to 5 ' + unit });
  big.forEach(function (s) { PACK.push({ v: 'p' + s, label: s + ' ' + unit }); });
  function inPack(d, key) {
    if (key === 's') return d.sizes.some(function (s) { return s <= 5; });
    return d.sizes.indexOf(Number(key.slice(1))) > -1;
  }
  var shownPack = PACK.length > 1 && units.length === 1 && PACK.some(function (p) { return count(function (d) { return inPack(d, p.v); }) < data.length; });

  /* option groups straight from the variants */
  var optNames = [], optMap = {};
  data.forEach(function (d) {
    d.on.forEach(function (n, k) {
      if (!n || n === 'title' || n === 'option') return;
      if (!optMap[n]) { optMap[n] = { name: d.onames[k], vals: [] }; optNames.push(n); }
      d.V.forEach(function (v) {
        var raw = cleanVal(v.raw[k]), lv = raw.toLowerCase();
        if (lv === 'default' || lv === 'default title') return;
        if (!optMap[n].vals.some(function (x) { return x.toLowerCase() === lv; })) optMap[n].vals.push(raw);
      });
    });
  });
  function hasOptVal(d, n, lv) { var k = d.on.indexOf(n); return k > -1 && d.V.some(function (v) { return v.o[k] === lv; }); }
  var optGroups = [];
  optNames.forEach(function (n, gi) {
    var col = isColName(n), size = isSizeName(n);
    if ((col && shownCol) || (size && shownPack)) return;
    var vals = optMap[n].vals;
    if (vals.length < 2 || vals.length > 40) return;
    var narrows = vals.some(function (v) { return count(function (d) { return hasOptVal(d, n, v.toLowerCase()); }) < data.length; });
    if (!narrows) return;
    if (vals.every(function (v) { return /^\d/.test(v) && !isNaN(numOf(v)); })) {
      vals.sort(function (a, b) { return unitOf(a).toLowerCase().localeCompare(unitOf(b).toLowerCase()) || numOf(a) - numOf(b); });
    }
    var nm = optMap[n].name;
    var label = size ? 'Pack size' : nm.charAt(0).toUpperCase() + nm.slice(1).toLowerCase();
    optGroups.push({ key: 'o' + gi, label: label, lvl: 'v', n: n, col: col, size: size,
      style: col ? 'list' : (size || vals.length <= 10 ? 'pills' : 'list'),
      opts: vals.map(function (v) { var c = col ? niceColour(v) : { t: v, s: '' }; return { v: v.toLowerCase(), label: c.t, small: c.s, unit: size ? unitOf(v) : '' }; }) });
  });
  optGroups.sort(function (a, b) { return (b.col ? 2 : b.size ? 1 : 0) - (a.col ? 2 : a.size ? 1 : 0); });
  optGroups.forEach(function (g) { groups.push(g); });
  if (shownPack) groups.push({ key: 'pack', label: 'Pack size needed', lvl: 'p', style: 'pills', opts: PACK, test: inPack });

  groups.push({ key: 'price', label: 'Price', sub: 'from price', lvl: 'x', style: 'checks',
    opts: BANDS.map(function (b) { return { v: b[0], label: b[1], lo: b[2], hi: b[3] }; }) });
  groups.push({ key: 'stock', label: 'Availability', lvl: 'x', style: 'checks', opts: [{ v: 'in', label: 'In stock' }] });
  var G = {}; groups.forEach(function (g) { G[g.key] = g; });

  var st = { room: null, sel: {}, sort: 'featured' };
  groups.forEach(function (g) { st.sel[g.key] = []; });

  /* ---------- matching ---------- */
  function band(key) { for (var i = 0; i < BANDS.length; i++) if (BANDS[i][0] === key) return BANDS[i]; return null; }
  function variantsFor(d, sel, room) {
    if (room && d.rooms.indexOf(room) < 0) return null;
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i], s = sel[g.key];
      if (g.lvl !== 'p' || !s || !s.length) continue;
      if (!s.some(function (v) { return g.test(d, v); })) return null;
    }
    var vg = groups.filter(function (g) { return g.lvl === 'v' && sel[g.key] && sel[g.key].length; });
    var needStock = sel.stock && sel.stock.length;
    var vs = d.V.filter(function (v) {
      if (needStock && !v.a) return false;
      for (var j = 0; j < vg.length; j++) {
        var k = d.on.indexOf(vg[j].n);
        if (k < 0 || sel[vg[j].key].indexOf(v.o[k]) < 0) return false;
      }
      return true;
    });
    if (!d.V.length) vs = [{ id: 0, raw: [], o: [], p: d.price, a: true, img: '' }];
    if (!vs.length) return null;
    if (sel.price && sel.price.length) {
      var pm = Math.min.apply(null, vs.map(function (v) { return v.p; }));
      if (!sel.price.some(function (k) { var b = band(k); return b && pm >= b[2] && pm < b[3]; })) return null;
    }
    return vs;
  }
  function withOnly(key, v) {
    var s = {}; for (var k in st.sel) s[k] = st.sel[k];
    s[key] = [v]; return s;
  }
  function anyVariantFilter() {
    return groups.some(function (g) { return (g.lvl === 'v' || g.key === 'stock') && st.sel[g.key].length; });
  }

  /* ---------- filter UI ---------- */
  var box = $('[data-rfc-filters]');
  var html = '';
  var COLOUR_SHOW = 6;
  groups.forEach(function (g) {
    var rows = '';
    var lastUnit = null, units2 = [];
    if (g.size) g.opts.forEach(function (o) { if (o.unit && units2.indexOf(o.unit) < 0) units2.push(o.unit); });
    g.opts.forEach(function (o, oi) {
      var id = 'rfc-' + g.key + '-' + oi;
      var more = g.col && g.opts.length > COLOUR_SHOW + 2 && oi >= COLOUR_SHOW ? ' data-more' : '';
      if (g.size && units2.length > 1 && o.unit !== lastUnit) {
        rows += '<p class="rfc-unit">' + (/^k?g$/i.test(o.unit) ? 'Weight (' + o.unit + ')' : /^m?l$/i.test(o.unit) ? 'Volume (' + o.unit + ')' : o.unit) + '</p>';
        lastUnit = o.unit;
      }
      if (g.style === 'pills') {
        rows += '<label class="rfc-pill" data-o="' + esc(o.v) + '"' + more + '><input type="checkbox" id="' + id + '" data-g="' + g.key + '" value="' + esc(o.v) + '"><span>' + esc(o.label) +
          (o.small ? ' <i>' + esc(o.small) + '</i>' : '') + '<small data-n></small></span></label>';
      } else {
        rows += '<label class="rfc-opt" data-o="' + esc(o.v) + '"' + more + '><input type="checkbox" id="' + id + '" data-g="' + g.key + '" value="' + esc(o.v) + '">' +
          (g.style === 'finish' ? '<span class="rfc-opt__box" aria-hidden="true"></span><span class="rfc-opt__sw rfc-opt__sw--' + o.v + '" aria-hidden="true"></span>' : '<span class="rfc-opt__box" aria-hidden="true"></span>') +
          '<span class="rfc-opt__t">' + esc(o.label) + (o.small ? '<small>' + esc(o.small) + '</small>' : '') + '</span><span class="rfc-opt__n" data-n></span></label>';
      }
    });
    var hasMore = g.col && g.opts.length > COLOUR_SHOW + 2;
    html += '<details class="rfc-fg" data-fg="' + g.key + '" open><summary><span class="rfc-fg__h">' + esc(g.label) + (g.sub ? '<small>' + esc(g.sub) + '</small>' : '') + '</span><span class="rfc-fg__sel" data-fg-sel></span></summary>' +
      '<fieldset><legend class="rfh-sr">' + esc(g.label) + '</legend>' +
      (g.key === 'kind' ? '<div class="rfc-pills"><label class="rfc-pill rfc-pill--all"><input type="checkbox" data-kind-all checked><span>All ' + esc(root.getAttribute('data-noun') || 'products') + '</span></label>' : (g.style === 'pills' ? '<div class="rfc-pills">' : '<div class="rfc-opts">')) +
      rows + '</div>' +
      (hasMore ? '<button type="button" class="rfc-more-btn" data-more-btn aria-expanded="false">Show all ' + g.opts.length + ' colours</button>' : '') +
      '</fieldset></details>';
  });
  if (box) box.innerHTML = html;
  var hasAny = !!html;
  var openBtn = $('[data-rfc-open]');
  if (!hasAny && openBtn) openBtn.style.display = 'none';

  function labelOf(key, v) {
    if (key === 'room') return roomNames[v] || 'Room';
    var g = G[key]; if (!g) return v;
    for (var i = 0; i < g.opts.length; i++) if (g.opts[i].v === v) return g.opts[i].label + (g.opts[i].small && g.col ? ' (' + g.opts[i].small + ')' : '');
    return v;
  }

  /* ---------- cards: price, matching options, image, link ---------- */
  function sizeIdx(d) { for (var k = 0; k < d.on.length; k++) if (isSizeName(d.on[k]) && d.optVals(d.on[k]).length > 1) return k; return -1; }
  function colIdx(d) { for (var k = 0; k < d.on.length; k++) if (isColName(d.on[k])) return k; return -1; }
  function uniq(list) { var o = []; list.forEach(function (x) { if (o.indexOf(x) < 0) o.push(x); }); return o; }
  function paintCard(d, vs, filtered) {
    var pm = Math.min.apply(null, vs.map(function (v) { return v.p; }));
    var varies = uniq(vs.map(function (v) { return v.p; })).length > 1;
    d.shown = pm;
    if (d.pEl) d.pEl.textContent = money(pm);
    if (d.fromEl) d.fromEl.hidden = !varies;
    var si = sizeIdx(d), basis = '';
    if (si > -1) {
      var cheap = vs.filter(function (v) { return v.p === pm; });
      var cs = uniq(cheap.map(function (v) { return cleanVal(v.raw[si]); }));
      if (cs.length === 1) basis = (varies ? 'for ' : '') + cs[0];
    }
    if (d.basisEl) d.basisEl.textContent = basis ? '· ' + basis : '';
    /* matching options */
    var ci = colIdx(d), parts = [];
    var colOn = groups.some(function (g) { return g.lvl === 'v' && g.col && st.sel[g.key].length && d.on.indexOf(g.n) > -1; });
    var sizeOn = groups.some(function (g) { return g.lvl === 'v' && g.size && st.sel[g.key].length && d.on.indexOf(g.n) > -1; });
    var mcols = ci > -1 ? uniq(vs.map(function (v) { return String(v.raw[ci]).trim(); })) : [];
    if (filtered && colOn && mcols.length) parts.push('Available in ' + mcols.join(', '));
    if (d.match) { d.match.textContent = parts.join(' · '); d.match.hidden = !parts.length; }
    /* size chips: matching sizes first, the rest marked as other options */
    if (d.chips) {
      if (filtered && sizeOn && si > -1) {
        var all = d.optVals(d.on[si]), ms = uniq(vs.map(function (v) { return cleanVal(v.raw[si]); }));
        var h = ms.map(function (s) { return '<li class="is-match"><span class="rfh-sr">Matching size: </span>' + esc(s) + '</li>'; }).join('');
        var others = all.filter(function (s) { return ms.indexOf(s) < 0; });
        if (others.length) h += '<li class="is-other">Also ' + esc(others.join(', ')) + '</li>';
        d.chips.innerHTML = h;
      } else if (d.chips.innerHTML !== d.chipsHTML) d.chips.innerHTML = d.chipsHTML;
    }
    /* image: variant photo when one colour is chosen and the variant has its own photo */
    var photo = '';
    if (filtered && colOn && mcols.length === 1) { var pv = vs.filter(function (v) { return v.img; })[0]; if (pv) photo = pv.img; }
    if (d.img) {
      if (photo) { d.img.setAttribute('src', photo); d.img.removeAttribute('srcset'); }
      else if (d.img.getAttribute('src') !== d.imgSrc) { d.img.setAttribute('src', d.imgSrc); if (d.imgSet) d.img.setAttribute('srcset', d.imgSet); }
    }
    if (d.note) {
      var showNote = filtered && colOn && mcols.length && !photo;
      d.note.textContent = showNote ? 'Photo may show a different colour' : '';
      d.note.hidden = !showNote;
    }
    /* link straight to the variant only when the choice points to exactly one */
    var href = d.url;
    if (filtered && vs.length === 1 && vs[0].id) href = d.url + (d.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vs[0].id;
    d.links.forEach(function (a) { a.setAttribute('href', href); });
  }

  /* ---------- apply ---------- */
  var countEl = $('[data-rfc-count]'), shownEl = $('[data-rfc-shown]'), emptyEl = $('[data-rfc-empty]'), activeEl = $('[data-rfc-active]');
  var fcount = $('[data-rfc-fcount]');
  var noun = countEl ? countEl.textContent.replace(/^\s*\d+\s+of\s+\d+\s+/, '') : 'products';
  root.setAttribute('data-noun', noun);
  function apply() {
    var filtered = anyVariantFilter();
    var n = 0, res = [];
    data.forEach(function (d) {
      var vs = variantsFor(d, st.sel, st.room);
      d.el.hidden = !vs;
      if (vs) { n++; paintCard(d, vs, filtered); } else d.shown = d.price;
      res.push(d);
    });
    var list = res.slice();
    if (st.sort === 'price-asc') list.sort(function (a, b) { return a.shown - b.shown || a.i - b.i; });
    else if (st.sort === 'price-desc') list.sort(function (a, b) { return b.shown - a.shown || a.i - b.i; });
    else if (st.sort === 'name') list.sort(function (a, b) { return a.name.localeCompare(b.name); });
    else list.sort(function (a, b) { return a.i - b.i; });
    list.forEach(function (d) { grid.appendChild(d.el); });
    if (countEl) countEl.innerHTML = '<strong>' + n + '</strong> of ' + data.length + ' ' + noun;
    if (shownEl) shownEl.textContent = n;
    if (emptyEl) emptyEl.hidden = n > 0;

    /* counts: each option with every other active group applied; zero-result options are disabled unless selected */
    groups.forEach(function (g) {
      var det = $('[data-fg="' + g.key + '"]', box);
      if (!det) return;
      var visible = 0;
      g.opts.forEach(function (o) {
        var lab = $('[data-o="' + (window.CSS && CSS.escape ? CSS.escape(o.v) : o.v) + '"]', det);
        if (!lab) return;
        var inp = $('input', lab), on = st.sel[g.key].indexOf(o.v) > -1;
        var c = count(function (d) { return variantsFor(d, withOnly(g.key, o.v), st.room); });
        var nEl = $('[data-n]', lab);
        if (nEl) nEl.textContent = c;
        inp.checked = on;
        inp.disabled = !on && c === 0;
        lab.classList.toggle('is-off', !on && c === 0);
        lab.setAttribute('title', !on && c === 0 ? 'No matching products with your other choices' : '');
        if (g.key === 'price' || g.key === 'stock') {
          var any = count(function (d) { return variantsFor(d, withOnly(g.key, o.v), null); }) > 0;
          lab.hidden = !any && !on;
          if (!lab.hidden) visible++;
        } else visible++;
      });
      if (g.key === 'price') det.hidden = visible < 2;
      if (g.key === 'stock') det.hidden = data.every(function (d) { return d.V.every(function (v) { return v.a; }); }) && !st.sel.stock.length;
      var selN = st.sel[g.key].length;
      $('[data-fg-sel]', det).textContent = selN ? selN + ' selected' : '';
      if (selN && !det.open) det.open = true;
      var allBox = $('[data-kind-all]', det);
      if (allBox) allBox.checked = !selN;
    });

    /* active filter tags */
    var chips = [];
    if (st.room) chips.push(['room', st.room, labelOf('room', st.room)]);
    groups.forEach(function (g) { st.sel[g.key].forEach(function (v) { chips.push([g.key, v, labelOf(g.key, v)]); }); });
    if (activeEl) {
      activeEl.hidden = !chips.length;
      activeEl.innerHTML = chips.map(function (c) {
        return '<button type="button" class="rfc-chip" data-rm-g="' + c[0] + '" data-rm-v="' + esc(c[1]) + '">' + esc(c[2]) +
          '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3 3 9"/></svg><span class="rfh-sr">, remove filter</span></button>';
      }).join('') + (chips.length ? '<button type="button" class="rfc-link" data-rfc-clear>Clear all</button>' : '');
    }
    if (fcount) { fcount.textContent = chips.length ? ' (' + chips.length + ')' : ''; fcount.hidden = !chips.length; }
    $$('[data-rfc-room]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-rfc-room') === st.room ? 'true' : 'false'); });
    syncMore();
    save();
  }
  function clearAll() { st.room = null; groups.forEach(function (g) { st.sel[g.key] = []; }); apply(); }

  /* colour lists: first few, "Show all", selected colours always visible */
  function syncMore() {
    $$('[data-more-btn]', box).forEach(function (btn) {
      var open = btn.getAttribute('aria-expanded') === 'true';
      var det = btn.closest('details');
      $$('[data-more]', det).forEach(function (lab) { lab.hidden = !open && !$('input', lab).checked; });
    });
  }
  if (box) box.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-more-btn]');
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var g = G[btn.closest('details').getAttribute('data-fg')];
    btn.textContent = open ? 'Show fewer colours' : 'Show all ' + g.opts.length + ' colours';
    syncMore();
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-kind-all')) { st.sel.kind = []; apply(); return; }
    var g = t.getAttribute('data-g');
    if (g && st.sel[g]) {
      var arr = st.sel[g], i = arr.indexOf(t.value);
      if (t.checked && i < 0) arr.push(t.value);
      if (!t.checked && i > -1) arr.splice(i, 1);
      apply();
    }
    if (t.hasAttribute('data-rfc-sort')) { st.sort = t.value; apply(); }
  });
  root.addEventListener('click', function (e) {
    var room = e.target.closest('[data-rfc-room]');
    if (room) {
      var k = room.getAttribute('data-rfc-room');
      st.room = st.room === k ? null : k;
      apply();
      var res = document.getElementById('rfc-results');
      if (res && st.room && res.getBoundingClientRect().top > window.innerHeight * 0.6) res.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    var rm = e.target.closest('[data-rm-g]');
    if (rm) {
      var g = rm.getAttribute('data-rm-g'), v = rm.getAttribute('data-rm-v');
      if (g === 'room') st.room = null; else st.sel[g].splice(st.sel[g].indexOf(v), 1);
      apply();
      var next = activeEl && activeEl.querySelector('button');
      (next || $('[data-rfc-sort]')).focus();
      return;
    }
    if (e.target.closest('[data-rfc-clear]')) { clearAll(); var s = $('[data-rfc-sort]'); if (s) s.focus(); }
  });

  /* ---------- keep choices for the back button ---------- */
  var KEY = 'rfc:' + (root.getAttribute('data-rfc-key') || location.pathname);
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify({ sel: st.sel, room: st.room, sort: st.sort })); } catch (e) {} }
  function restore() {
    try {
      var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (!s) return;
      if (s.sel) groups.forEach(function (g) {
        (s.sel[g.key] || []).forEach(function (v) { if (g.opts.some(function (o) { return o.v === v; })) st.sel[g.key].push(v); });
      });
      if (s.room && roomNames[s.room]) st.room = s.room;
      if (s.sort) { st.sort = s.sort; var sel = $('[data-rfc-sort]'); if (sel) sel.value = s.sort; }
    } catch (e) {}
  }
  window.addEventListener('pagehide', function () { try { sessionStorage.setItem(KEY + ':y', String(window.scrollY)); } catch (e) {} });

  /* ---------- filter panel on smaller screens ---------- */
  var side = $('[data-rfc-side]');
  function setPanel(open, toResults) {
    if (!side || !openBtn) return;
    side.classList.toggle('is-open', open);
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var f = side.querySelector('summary, input, button'); if (f) f.focus(); }
    else if (toResults) {
      var r = document.getElementById('rfc-results');
      if (r) r.scrollIntoView({ block: 'start', behavior: 'auto' });
      openBtn.focus({ preventScroll: true });
    } else openBtn.focus();
  }
  if (openBtn) openBtn.addEventListener('click', function () { setPanel(!side.classList.contains('is-open')); });
  $$('[data-rfc-close]').forEach(function (b) { b.addEventListener('click', function () { setPanel(false, b.hasAttribute('data-rfc-done')); }); });
  if (side) side.addEventListener('keydown', function (e) { if (e.key === 'Escape' && side.classList.contains('is-open')) setPanel(false); });
  function groupsForScreen() {
    $$('details[data-fg]', box).forEach(function (det) {
      var key = det.getAttribute('data-fg');
      det.open = !mqSmall.matches || st.sel[key].length > 0 || key === 'kind';
    });
  }
  if (mqSmall.addEventListener) mqSmall.addEventListener('change', groupsForScreen);

  /* ---------- buying guide: columns fold on phones ---------- */
  var gcols = $$('[data-rfc-gcol]', document);
  function guideForScreen() { gcols.forEach(function (c, k) { c.open = !mqPhone.matches || k === 0; }); }
  gcols.forEach(function (c) { $('summary', c).addEventListener('click', function (e) { if (!mqPhone.matches) e.preventDefault(); }); });
  if (mqPhone.addEventListener) mqPhone.addEventListener('change', guideForScreen);
  guideForScreen();

  /* ---------- compare ---------- */
  var tray = $('[data-rfc-tray]'), trayN = $('[data-rfc-tray-n]'), trayList = $('[data-rfc-tray-list]');
  var dlg = $('[data-rfc-dlg]'), dlgBody = $('[data-rfc-dlg-body]'), cue = $('[data-rfc-dlg-cue]');
  var picked = [], opener = null, MAX = 3;
  function byI(i) { for (var k = 0; k < data.length; k++) if (data[k].i === i) return data[k]; return null; }
  function syncCmp() {
    $$('[data-rfc-cmp]').forEach(function (cb) {
      var on = picked.indexOf(Number(cb.value)) > -1;
      cb.checked = on;
      cb.disabled = !on && picked.length >= MAX;
      var lab = cb.closest('label');
      if (lab) lab.title = cb.disabled ? 'You can compare up to ' + MAX + ' products. Remove one to add another.' : '';
    });
    if (tray) {
      tray.hidden = picked.length === 0;
      trayN.textContent = picked.length;
      trayList.innerHTML = picked.map(function (i) {
        var d = byI(i);
        return '<li><span>' + esc(d.name) + '</span><button type="button" data-cmp-rm="' + i + '" aria-label="Remove ' + esc(d.name) + ' from comparison"><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3 3 9"/></svg></button></li>';
      }).join('');
      document.body.style.paddingBottom = picked.length ? tray.offsetHeight + 'px' : '';
    }
    var open = $('[data-rfc-cmp-open]');
    if (open) { open.disabled = picked.length < 2; open.textContent = picked.length < 2 ? 'Pick 2 to compare' : 'Compare ' + picked.length; }
  }
  root.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-rfc-cmp]');
    if (!cb) return;
    var i = Number(cb.value), at = picked.indexOf(i);
    if (cb.checked && at < 0 && picked.length < MAX) picked.push(i);
    if (!cb.checked && at > -1) picked.splice(at, 1);
    syncCmp();
  });
  if (tray) tray.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cmp-rm]');
    if (!b) return;
    var i = Number(b.getAttribute('data-cmp-rm'));
    picked.splice(picked.indexOf(i), 1);
    syncCmp();
    var nb = trayList.querySelector('button') || $('[data-rfc-cmp-open]');
    if (nb) nb.focus();
  });
  var clr = $('[data-rfc-cmp-clear]');
  if (clr) clr.addEventListener('click', function () { picked = []; syncCmp(); });

  function sizesText(d) {
    var k = -1; for (var j = 0; j < d.on.length; j++) if (isSizeName(d.on[j])) k = j;
    var list = k > -1 ? d.optVals(d.on[k]).filter(function (s) { return !/^default/i.test(s); }) : [];
    list.sort(function (a, b) { return unitOf(a).toLowerCase().localeCompare(unitOf(b).toLowerCase()) || numOf(a) - numOf(b); });
    var t = list.join(', ');
    if (d.packnote) t = t ? t + ' — ' + d.packnote : d.packnote;
    return t;
  }
  function coloursText(d) {
    var k = colIdx(d); if (k < 0) return '';
    var list = d.optVals(d.on[k]);
    if (list.length < 2 && /default/i.test(list[0] || '')) return '';
    return list.length + (list.length === 1 ? ' colour: ' : ' colours: ') + list.join(', ');
  }
  function priceText(d) {
    var ps = d.V.map(function (v) { return v.p; }); if (!ps.length) ps = [d.price];
    var pm = Math.min.apply(null, ps), varies = uniq(ps).length > 1, basis = '';
    var si = sizeIdx(d);
    if (si > -1 && varies) { var cs = uniq(d.V.filter(function (v) { return v.p === pm; }).map(function (v) { return cleanVal(v.raw[si]); })); if (cs.length === 1) basis = ' for ' + cs[0]; }
    return (varies ? 'From ' : '') + money(pm) + (VAT ? ' ' + VAT : '') + basis;
  }
  var ROWS = [
    ['Product type', function (d) { return d.klabel; }],
    ['What’s included', function (d) { return d.includes; }],
    ['Pack sizes', sizesText],
    ['Colours', coloursText],
    ['Finish', function (d) { return d.flabel; }],
    ['Coverage', function (d) { return d.coverage; }],
    ['Suited to', function (d) { var r = d.rooms.filter(function (k) { return k !== 'ral'; }).map(function (k) { return roomNames[k]; }).filter(Boolean); return r.join(', '); }],
    ['Price', priceText]
  ];
  function renderCompare() {
    var ds = picked.map(byI);
    var rows = ROWS.filter(function (r) { return ds.some(function (d) { return r[1](d); }); });
    var h;
    if (mqPhone.matches) {
      h = '<div class="rfc-cmpc">' + ds.map(function (d) {
        return '<article class="rfc-cmpc__i"><h3><a href="' + esc(d.url) + '">' + esc(d.name) + '</a></h3><dl>' +
          rows.map(function (r) { var v = r[1](d); return '<div><dt>' + r[0] + '</dt><dd' + (v ? '' : ' class="is-na"') + '>' + esc(v || 'Not specified') + '</dd></div>'; }).join('') + '</dl></article>';
      }).join('') + '</div>';
    } else {
      h = '<table><caption class="rfh-sr">Comparison of ' + ds.length + ' products</caption><thead><tr><td></td>' + ds.map(function (d) { return '<th scope="col"><a href="' + esc(d.url) + '">' + esc(d.name) + '</a></th>'; }).join('') + '</tr></thead><tbody>';
      rows.forEach(function (r) { h += '<tr><th scope="row">' + r[0] + '</th>' + ds.map(function (d) { var v = r[1](d); return '<td' + (v ? '' : ' class="is-na"') + '>' + esc(v || 'Not specified') + '</td>'; }).join('') + '</tr>'; });
      h += '</tbody></table>';
    }
    dlgBody.innerHTML = h;
    if (cue) cue.hidden = !(dlgBody.scrollWidth > dlgBody.clientWidth + 2);
  }
  var openCmp = $('[data-rfc-cmp-open]');
  if (openCmp && dlg) openCmp.addEventListener('click', function () {
    if (picked.length < 2) return;
    opener = openCmp;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    renderCompare();
    var x = $('[data-rfc-dlg-close]'); if (x) x.focus();
  });
  var x = $('[data-rfc-dlg-close]');
  if (x && dlg) x.addEventListener('click', function () { if (dlg.close) dlg.close(); else { dlg.removeAttribute('open'); if (opener) opener.focus(); } });
  if (dlg) {
    dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
    dlg.addEventListener('close', function () { if (opener && document.contains(opener)) opener.focus(); });
    window.addEventListener('resize', function () { if (dlg.open) renderCompare(); });
  }
  window.addEventListener('resize', function () { if (tray && !tray.hidden) document.body.style.paddingBottom = tray.offsetHeight + 'px'; });

  /* ---------- go ---------- */
  restore();
  groupsForScreen();
  apply();
  syncCmp();
  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var y = Number(sessionStorage.getItem(KEY + ':y'));
    if (nav && nav.type === 'back_forward' && y > 0) window.scrollTo(0, y);
  } catch (e) {}

  /* test hook (read-only): lets automated checks read the matching model */
  root.rfcDebug = { groups: groups, data: data, st: st, variantsFor: variantsFor };
})();
